import { FaInstagram, FaFacebook } from "react-icons/fa";

export default function Footer() {
  return (
    <footer className="relative footer pt-20 pb-10">
      <div className="container grid grid-cols-1 md:grid-cols-4 gap-12">

        {/* Brand */}
        <div>
          <img src="/logo-icon.png" alt="LoanPulse" className="h-10 w-10" />
          <h3 className="text-2xl font-extrabold text-[var(--primary)]">
            LoanPulse
          </h3>

          <p className="mt-3 font-medium text-white">
            Loan Journey, Simplified
          </p>

          {/* Social Icons */}
          <div className="mt-6 flex items-center gap-4">
            <a
              href="https://www.instagram.com/loanpulse"
              target="_blank"
              rel="noreferrer"
              aria-label="LoanPulse LinkedIn"
              className="w-10 h-10 rounded-full flex items-center justify-center
                         border border-white
                         text-white
                         hover:bg-[var(--primary)]
                         hover:text-white
                         transition"
            >
              <FaInstagram size={18} />
            </a>

            <a
              href="https://facebook.com/loanpulse"
              target="_blank"
              rel="noreferrer"
              aria-label="LoanPulse WhatsApp"
              className="w-10 h-10 rounded-full flex items-center justify-center
                         border border-white
                         text-white
                         hover:bg-[#0165E1]
                         hover:text-white
                         transition"
            >
              <FaFacebook size={18} />
            </a>
          </div>
        </div>

        {/* Links */}
        <div>
          <h4 className="text-sm font-semibold uppercase tracking-wider text-[var(--secondary)]">
            Links
          </h4>

          <ul className="mt-4 space-y-3 text-white">
            <li><a href="#features" className="text-white hover:text-[var(--primary)] transition">Features</a></li>
            <li><a href="#how-it-works" className="text-white hover:text-[var(--primary)] transition">How it works</a></li>
            
            
            <li><a href="#ourstory" className="text-white hover:text-[var(--primary)] transition">Our Story</a></li>
          </ul>
        </div>

        {/* Support */}
        <div>
          <h4 className="text-sm font-semibold uppercase tracking-wider text-[var(--secondary)]">
            Support
          </h4>

          <ul className="mt-4 space-y-3 text-white">
            <li><a href="/help" className="text-white hover:text-[var(--primary)] transition">Help desk</a></li>
            <li>
              <a
                href="/"
                target="_blank"
                rel="noreferrer"
                className="text-white hover:text-[var(--primary)] transition"
              >
                WhatsApp support
              </a>
            </li>
            <li><a href="/docs" className="text-white hover:text-[var(--primary)] transition">Documentation</a></li>
          </ul>
        </div>

        {/* Legal */}
        <div>
          <h4 className="text-sm font-semibold uppercase tracking-wider text-[var(--secondary)]">
            Legal
          </h4>

          <ul className="mt-4 space-y-3 text-white">
            <li><a href="/privacy-policy" className="text-white hover:text-[var(--primary)] transition">Privacy Policy</a></li>
            <li><a href="/terms" className="text-white hover:text-[var(--primary)] transition">Terms & Conditions</a></li>
          </ul>
        </div>

      </div>

      {/* Bottom */}
      <div className="mt-16 border-t border-[var(--border)] pt-8 text-center text-sm text-white">
        © {new Date().getFullYear()} LoanPulse. All rights reserved.
      </div>
    </footer>
  );
}
